import { Route, Routes } from 'react-router-dom'
import { TableAnalysisPurchasesInvoiceDetailed } from './table/table'


export const BrowserAnalysisPurchasesInvoicesDetailed = () => {
    return (
        <Routes>
            <Route path={"/"} element={<TableAnalysisPurchasesInvoiceDetailed />} />
        </Routes>
    )
}